import React, { SVGProps } from "react";

export default function SupToggleLeft(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.6 9.99995C7.6 10.8836 6.88366 11.6 6 11.6C5.11634 11.6 4.4 10.8836 4.4 9.99995C4.4 9.1163 5.11634 8.39995 6 8.39995C6.88366 8.39995 7.6 9.1163 7.6 9.99995ZM6.8 9.99995C6.8 10.4418 6.44183 10.8 6 10.8C5.55817 10.8 5.2 10.4418 5.2 9.99995C5.2 9.55812 5.55817 9.19995 6 9.19995C6.44183 9.19995 6.8 9.55812 6.8 9.99995Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.8 5.19995C4.14903 5.19995 2 7.34898 2 9.99995C2 12.6509 4.14903 14.8 6.8 14.8H13.2C15.851 14.8 18 12.6509 18 9.99995C18 7.34898 15.851 5.19995 13.2 5.19995H6.8ZM13.2 5.99995H6.8C4.59086 5.99995 2.8 7.79081 2.8 9.99995C2.8 12.2091 4.59086 14 6.8 14H13.2C15.4091 14 17.2 12.2091 17.2 9.99995C17.2 7.79081 15.4091 5.99995 13.2 5.99995Z"
        fill="currentColor"
      />
    </svg>
  );
}
